var exports = {
  "x": "x4ddf2309--ba40bd--button",
  "j": "x4ddf2309--ba40bd--button-text",
};

module.exports = exports;
